var _style, _defs, _g, _defs2, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOncology(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 103 102",
    style: {
      enableBackground: "new 0 0 103 102"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{display:none;}\r\n\t.st1{display:inline;}\r\n\t.st2{clip-path:url(#SVGID_00000083788737682203249300000008850712449111181233_);}\r\n\t.st3{fill:#E86E7B;}\r\n\t.st4{clip-path:url(#SVGID_00000134244636363770648810000010414018273035178148_);}\r\n\t.st5{fill:none;stroke:#000000;stroke-width:6;stroke-miterlimit:10;}\r\n")), /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 0.5,
    y: 0,
    width: 102,
    height: 102
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000039094372740633924240000011906554756674342552_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000039094372740633924240000011906554756674342552_)"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M98.2,93.5h-85c-1.1,0-2.2-0.4-3-1.2c-0.8-0.8-1.2-1.9-1.2-3v-85c0-1.1-0.4-2.2-1.2-3C7,0.4,5.9,0,4.8,0 s-2.2,0.4-3,1.2C0.9,2,0.5,3.1,0.5,4.2v85c0,3.4,1.3,6.6,3.7,9s5.6,3.7,9,3.7h85c1.1,0,2.2-0.4,3-1.2c0.8-0.8,1.2-1.9,1.2-3 s-0.4-2.2-1.2-3C100.5,93.9,99.4,93.5,98.2,93.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M64.3,85c1.1,0,2.2-0.4,3-1.2c0.8-0.8,1.2-1.9,1.2-3V51c0-1.1-0.4-2.2-1.2-3c-0.8-0.8-1.9-1.2-3-1.2 s-2.2,0.4-3,1.2S60,49.9,60,51v29.8c0,1.1,0.4,2.2,1.2,3S63.1,85,64.3,85z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M30.2,85c1.1,0,2.2-0.4,3-1.2c0.8-0.8,1.2-1.9,1.2-3V51c0-1.1-0.4-2.2-1.2-3s-1.9-1.2-3-1.2 s-2.2,0.4-3,1.2S26,49.9,26,51v29.8c0,1.1,0.4,2.2,1.2,3C28,84.6,29.1,85,30.2,85z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M81.2,85c1.1,0,2.2-0.4,3-1.2c0.8-0.8,1.2-1.9,1.2-3v-51c0-1.1-0.4-2.2-1.2-3c-0.8-0.8-1.9-1.2-3-1.2 s-2.2,0.4-3,1.2c-0.8,0.8-1.2,1.9-1.2,3v51c0,1.1,0.4,2.2,1.2,3C79,84.6,80.1,85,81.2,85z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M47.2,85c1.1,0,2.2-0.4,3-1.2c0.8-0.8,1.2-1.9,1.2-3v-51c0-1.1-0.4-2.2-1.2-3s-1.9-1.2-3-1.2 s-2.2,0.4-3,1.2c-0.8,0.8-1.2,1.9-1.2,3v51c0,1.1,0.4,2.2,1.2,3S46.1,85,47.2,85z"
  }))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000034769443671127001380000008691403521959896251_",
    x: 5.4,
    y: 4.9,
    width: 92.2,
    height: 92.2
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000003068130739231246500000014478784875554810516_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000034769443671127001380000008691403521959896251_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000003068130739231246500000014478784875554810516_)"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40,97.1H20.8c-4.2,0-8.1-1.5-10.8-4.6c-3.1-3.1-4.6-6.9-4.6-10.8V62.5c0-4.2,1.5-8.1,4.6-10.8c3.1-3.1,6.9-4.6,10.8-4.6 H55c1.9,0,4.2,0.4,5.8,1.5c1.9,1.2,3.5,2.7,4.2,4.2l12.3-13.5c1.2-1.2,2.3-1.9,3.5-2.7c1.5-0.8,2.7-1.2,4.2-1.2 c1.5,0,3.1,0,4.6,0.8c1.5,0.4,2.7,1.2,3.8,2.3c2.3,1.9,3.5,5,3.8,8.1c0,3.1-0.8,6.1-3.1,8.5L68,84.4C64.6,88.7,60,91.7,55,94 C50.7,96,45.4,97.1,40,97.1z M20.8,54.8c-1.9,0-3.8,0.8-5.4,2.3s-2.3,3.5-2.3,5.4v19.2c0,1.9,0.8,3.8,2.3,5.4s3.5,2.3,5.4,2.3H40 c4.2,0,8.5-0.8,12.7-2.7c3.8-1.9,7.3-4.2,10.4-7.7l26.1-29.2c0.8-0.8,1.2-1.9,1.2-2.7c0-1.2-0.4-1.9-1.2-2.7 c-0.8-0.8-1.9-1.2-2.7-1.2c-0.4,0-1.2,0-1.5,0.4s-0.8,0.4-1.2,0.8L66.9,63.3c-0.8,1.9-1.9,3.8-3.8,5.4c-1.5,1.5-3.8,2.3-5.8,2.7 l-20,2.7c-1.2,0-1.9,0-2.7-0.8s-1.5-1.5-1.5-2.7c0-1.2,0-1.9,0.8-2.7s1.5-1.5,2.7-1.5l20-2.7c1.2,0,1.9-0.8,2.7-1.5 s1.2-1.9,1.2-3.1c0-1.2-0.4-2.3-1.5-3.1c-0.8-0.8-1.9-1.2-3.1-1.2H20.8z"
  }))))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M35.8,39.8c0,0,34.1-28,14-28S63.5,40,63.5,40"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOncology);
export default __webpack_public_path__ + "static/media/Oncology.fa717b6e389edc73347ddde3069a15f4.svg";
export { ForwardRef as ReactComponent };